var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorPlanEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "587px",
    height: "269px",
    viewBox: "0 0 587 269",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0AD4A1C9-2D36-4248-A08E-584664CA5622") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototype",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-124.000000, -1092.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor-plan-with-devices-Copy",
    transform: "translate(128.000000, 1096.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stairs",
    transform: "translate(248.000000, 156.500000)",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 65.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 42.5,
    y: 65.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0.5,
    y: 52.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 42.5,
    y: 52.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0.5,
    y: 39.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 42.5,
    y: 39.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 0.5,
    y: 26.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 42.5,
    y: 26.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 0.5,
    y: 13.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 42.5,
    y: 13.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 42.5,
    y: 0.5,
    width: 37,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0.5,
    y: 78.5,
    width: 79,
    height: 22
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-16",
    points: "27 0.710295291 27 89 53 89 53 0"
  })), /*#__PURE__*/React.createElement("text", {
    id: 101,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37,
    y: 42.5
  }, "101")), /*#__PURE__*/React.createElement("text", {
    id: 107,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#717171"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 510,
    y: 42.5
  }, "107")), /*#__PURE__*/React.createElement("text", {
    id: 103,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#717171"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 140,
    y: 42.5
  }, "103")), /*#__PURE__*/React.createElement("text", {
    id: 105,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#7D7D7D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 411,
    y: 42.5
  }, "105")), /*#__PURE__*/React.createElement("text", {
    id: 102,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#717171"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37,
    y: 218.5
  }, "102")), /*#__PURE__*/React.createElement("text", {
    id: 104,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#7D7D7D"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 160,
    y: 218.5
  }, "104")), /*#__PURE__*/React.createElement("text", {
    id: 108,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#888888"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 510,
    y: 218.5
  }, "108")), /*#__PURE__*/React.createElement("text", {
    id: 106,
    fontFamily: "TeleGroteskNext-Regular, TeleGrotesk Next",
    fontSize: 18,
    fontWeight: "normal",
    letterSpacing: 0.0228571329,
    fill: "#888888"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 387,
    y: 218.5
  }, "106")), /*#__PURE__*/React.createElement("g", {
    id: "Door",
    transform: "translate(37.000000, 74.750000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door-Copy-4",
    transform: "translate(408.000000, 74.750000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door-Copy-2",
    transform: "translate(158.500000, 91.750000) scale(-1, 1) translate(-158.500000, -91.750000) translate(141.000000, 74.750000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door-Copy-6",
    transform: "translate(537.500000, 91.750000) scale(-1, 1) translate(-537.500000, -91.750000) translate(520.000000, 74.750000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door-Copy",
    transform: "translate(54.500000, 168.500000) scale(1, -1) translate(-54.500000, -168.500000) translate(37.000000, 151.500000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door-Copy-5",
    transform: "translate(426.500000, 168.500000) scale(1, -1) translate(-426.500000, -168.500000) translate(409.000000, 151.500000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door-Copy-3",
    transform: "translate(149.500000, 168.500000) scale(-1, -1) translate(-149.500000, -168.500000) translate(132.000000, 151.500000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Door-Copy-7",
    transform: "translate(537.500000, 168.500000) scale(-1, -1) translate(-537.500000, -168.500000) translate(520.000000, 151.500000)",
    stroke: "#979797",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.05,
    y: 0.25,
    width: 1.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.25 C0,17.0365496 14.7746033,33.25 33,33.25 C33,33.25 33,22.25 33,0.25",
    id: "Path",
    transform: "translate(16.500000, 16.750000) scale(1, -1) translate(-16.500000, -16.750000) "
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    x: 0.5,
    y: 1,
    width: 578,
    height: 259
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,108.5 C551,108.5 551,72.5 551,0.5 L579,0.5",
    id: "Path-12",
    stroke: "#979797",
    strokeWidth: 8,
    strokeLinejoin: "round",
    transform: "translate(565.000000, 54.500000) scale(-1, 1) translate(-565.000000, -54.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,108.5 C0,108.5 0,72.5 0,0.5 L28,0.5",
    id: "Path-12-Copy-6",
    stroke: "#979797",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,108.5 C175,108.5 175,72.5 175,0.5 L203,0.5",
    id: "Path-12-Copy-2",
    stroke: "#979797",
    strokeWidth: 8,
    strokeLinejoin: "round",
    transform: "translate(189.000000, 54.500000) scale(-1, 1) translate(-189.000000, -54.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,108.5 C373,108.5 373,72.5 373,0.5 L401,0.5",
    id: "Path-12-Copy-3",
    stroke: "#979797",
    strokeWidth: 8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,259.5 C0,259.5 0,223.5 0,151.5 L28,151.5",
    id: "Path-12-Copy",
    stroke: "#979797",
    strokeWidth: 8,
    strokeLinejoin: "round",
    transform: "translate(14.000000, 205.500000) scale(1, -1) translate(-14.000000, -205.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551,259.5 C551,259.5 551,223.5 551,151.5 L579,151.5",
    id: "Path-12-Copy-5",
    stroke: "#979797",
    strokeWidth: 8,
    strokeLinejoin: "round",
    transform: "translate(565.000000, 205.500000) scale(-1, -1) translate(-565.000000, -205.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 107.5,
    x2: 141,
    y2: 107.5,
    id: "Path-14-Copy",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 260.5,
    x2: 407,
    y2: 260.5,
    id: "Path-13-Copy-3",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 0.5,
    x2: 407,
    y2: 0.5,
    id: "Path-13-Copy-2",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elevator-Copy",
    transform: "translate(221.000000, 16.500000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 1,
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 61,
    y2: 61,
    id: "Path-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 61,
    y2: 61,
    id: "Path-15-Copy",
    transform: "translate(31.500000, 31.500000) scale(-1, 1) translate(-31.500000, -31.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elevator-Copy-2",
    transform: "translate(292.000000, 16.500000)",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 1,
    width: 61,
    height: 61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 61,
    y2: 61,
    id: "Path-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 2,
    x2: 61,
    y2: 61,
    id: "Path-15-Copy",
    transform: "translate(31.500000, 31.500000) scale(-1, 1) translate(-31.500000, -31.500000) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332,260.5 C332,260.5 332,224.166667 332,151.5 L360,151.5",
    id: "Path-12-Copy-4",
    stroke: "#979797",
    strokeWidth: 8,
    strokeLinejoin: "round",
    transform: "translate(346.000000, 206.000000) scale(1, -1) translate(-346.000000, -206.000000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: 152.5,
    x2: 134,
    y2: 152.5,
    id: "Path-14-Copy-4",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447,
    y1: 1,
    x2: 511,
    y2: 0.5,
    id: "Path-13-Copy-7",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 152.5,
    x2: 37,
    y2: 152.5,
    id: "Path-14-Copy-5",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 107.5,
    x2: 37,
    y2: 107.5,
    id: "Path-14",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 555,
    y1: 107.5,
    x2: 579,
    y2: 107.5,
    id: "Path-14-Copy-15",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 555,
    y1: 152.5,
    x2: 576,
    y2: 152.5,
    id: "Path-14-Copy-16",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 260.5,
    x2: 244,
    y2: 151.5,
    id: "Path-13-Copy-8",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 152.5,
    x2: 106,
    y2: 260.5,
    id: "Path-14-Copy-3",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167,
    y1: 152.5,
    x2: 248,
    y2: 152.5,
    id: "Path-14-Copy-9",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 328,
    y1: 152.5,
    x2: 409,
    y2: 152.5,
    id: "Path-14-Copy-17",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 443,
    y1: 152.5,
    x2: 520,
    y2: 153,
    id: "Path-14-Copy-11",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472,
    y1: 152.5,
    x2: 472,
    y2: 260.5,
    id: "Path-14-Copy-10",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 259.5,
    x2: 148,
    y2: 259.5,
    id: "Path-13-Copy",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 447,
    y1: 260.5,
    x2: 511,
    y2: 260.5,
    id: "Path-13-Copy-6",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 104.5,
    x2: 221,
    y2: 104.5,
    id: "Path-13-Copy-4",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355,
    y1: 104.5,
    x2: 376,
    y2: 104.5,
    id: "Path-13-Copy-5",
    stroke: "#979797",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 442,
    y1: 107.5,
    x2: 521,
    y2: 107.5,
    id: "Path-14-Copy-13",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373,
    y1: 107.5,
    x2: 408,
    y2: 107.5,
    id: "Path-14-Copy-14",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472,
    y1: 0.5,
    x2: 472,
    y2: 108.5,
    id: "Path-14-Copy-12",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.5,
    y1: 0.5,
    x2: 106.5,
    y2: 108.5,
    id: "Path-14-Copy-2",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176,
    y1: 107.5,
    x2: 200,
    y2: 107.5,
    id: "Path-14-Copy-7",
    stroke: "#979797",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 0.5,
    x2: 131,
    y2: 0.5,
    id: "Path-13",
    stroke: "#979797",
    strokeWidth: 8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorPlanEmpty);
export default __webpack_public_path__ + "static/media/floor-plan-empty.810825fd07190d1a5fb3ebb587751cae.svg";
export { ForwardRef as ReactComponent };